/**
 * Тактильный отклик (PWA / мобильный браузер). Best-effort:
 * на устройствах без вибромотора или в десктопном браузере — no-op.
 */
export function haptic(pattern: number | number[] = 10): void {
  try {
    if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
      navigator.vibrate(pattern);
    }
  } catch {
    /* haptic feedback is best-effort */
  }
}
